export const DISMISSED_BANNERS_STORAGE_KEY = 'DismissedBannersStorageKey';
export const YES_KEY = 'true';

export enum BannerStorageKey {
  ImportantChangesBanner = 'ImportantChangesBanner',
  GoPaperlessBanner = 'GoPaperlessBanner',
  LinkedEmployeeBanner = 'LinkedEmployeeBanner',
  BeneficiaryBanner = 'BeneficiaryBanner',
  StayInTheKnowBanner = 'StayInTheKnowBanner',
}

export enum BannerActionCompleted {
  ImportantChangesBannerAction = 'ImportantChangesBannerAction',
}
